import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import PageIntro from "@/components/PageIntro";
import Reveal from "@/components/Reveal";
import InquiryForm from "@/components/InquiryForm";
import { publicLinks } from "@/data/siteData";

export default function Connect() {
  return (
    <main data-testid="connect-page">
      <PageIntro index="07" title="Connect" description="If you are thinking about data, analytics, AI, transformation or the decisions that connect them, I would be glad to hear from you." aside="A short note is enough. You can reach me on LinkedIn or by email, or use the form if you want to share a little more context." />
      <section className="page-section" style={{ paddingTop: 0 }}>
        <div className="shell connect-grid">
          <Reveal>
            <div className="channel-list" data-testid="direct-channels">
              <div className="channel"><span className="channel-label">Find me here</span><a className="channel-value" href={publicLinks.linkedin} target="_blank" rel="noreferrer noopener" data-testid="connect-linkedin-link" aria-label="Open Ashwini Patil on LinkedIn">LinkedIn profile <ArrowUpRight size={16} aria-hidden="true" /></a></div>
              <div className="channel"><span className="channel-label">Write to me</span><a className="channel-value" href={`mailto:${publicLinks.email}`} data-testid="connect-email-link">{publicLinks.email} <ArrowUpRight size={16} aria-hidden="true" /></a></div>
              <div className="channel"><span className="channel-label">Read the book</span><Link to="/book" className="channel-value" data-testid="connect-book-link">The Decision Gap <ArrowUpRight size={16} /></Link></div>
            </div>
            <p className="channel-note">A professional introduction, a speaking idea, a research question or a thoughtful disagreement are all good reasons to get in touch.</p>
          </Reveal>
          <Reveal delay={120}><InquiryForm /></Reveal>
        </div>
      </section>
    </main>
  );
}
